import { StatsBlockSb } from '@/components/findex-connect/types/component-types-sb'

import { StatCounter } from '../StatCounter/StatCounter'

export const StatsBlock: React.FC<{ data: StatsBlockSb }> = ({ data }) => {
  if (!data) return null
  const { heading, statistics } = data

  return (
    <div className="STATSBLOCK-CONTAINER mx-auto w-full bg-white">
      <div className="STATSBLOCK-INNER max-w-container p-gutter mx-auto flex w-full flex-col py-10 md:py-20">
        <div className="STATSBLOCK-HEADER max-w-container mx-auto mb-3 w-full md:mb-8">
          {heading && <h2 className="mb-6 md:mb-12">{heading}</h2>}
        </div>
        {statistics && <StatCounter data={statistics} />}
      </div>
    </div>
  )
}
